import script from "./DebugWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./DebugWrapper.vue?vue&type=script&setup=true&lang=js"

import "./DebugWrapper.vue?vue&type=style&index=0&id=120b4a09&scoped=true&lang=css"

import exportComponent from "../../../author/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-120b4a09"]])

export default __exports__